export const TOGGLE_EVENT_NAME = 'toggle'
export const SELECT_PLAN_EVENT_NAME = 'selectPlan'
export const POLICY_WORDING_CLICK_EVENT = 'policyWordingClick'
export const LEARN_MORE_POPUP_EVENT = 'openLearnMorePopup'
